// @flow
import Component from './main'
import ReceivedComponent from './Received/main'
import DepositsMain from './Forms/main'

export default () => ({
  path: 'deposits',
  children: [
    {
      path: '',
      element: <Component />,
    },
    {
      path: 'received',
      element: <ReceivedComponent />,
    },
    {
      path: ':id',
      element: <DepositsMain />,
    },
  ],
})
